// extracted by mini-css-extract-plugin
export var productImage = "_mj-0";